import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { Reveal, Eyebrow } from "./Reveal";
import { FAQ } from "./content";

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="py-24 md:py-36 bg-sand">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12">
      <div className="lg:col-span-4">
        <Reveal><Eyebrow>Perguntas frequentes</Eyebrow></Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-5 font-display text-4xl sm:text-5xl text-ink leading-[1.05] tracking-tight">
            Dúvidas <span className="italic text-sage">comuns</span>
          </h2>
        </Reveal>
      </div>
      <Reveal delay={0.15} className="lg:col-span-8">
        <Accordion type="single" collapsible className="border-t border-ink/15">
          {FAQ.map((f, i) => (
            <AccordionItem key={f.q} value={`f${i}`} className="border-b border-ink/15">
              <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-6 text-left font-display text-xl sm:text-2xl text-ink hover:no-underline hover:text-sage transition-colors">
                {f.q}
              </AccordionTrigger>
              <AccordionContent data-testid={`faq-content-${i}`} className="text-base text-ink/75 leading-relaxed pb-6 max-w-2xl">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
